/**
 * BNPL Prominent — syncs Pay-now / Total-value from the Dawn price block.
 * Monthly "as low as" stays as the merchant-set static string in the markup.
 */
(function () {
  var SCOPE = '.product__info-wrapper ';

  function q(sel) {
    return document.querySelector(sel);
  }
  function all(sel) {
    return Array.prototype.slice.call(document.querySelectorAll(sel));
  }

  function priceRoot() {
    return q(SCOPE + '[id^="price-"]') || q('[id^="price-"]');
  }

  function priceBox() {
    var root = priceRoot();
    return (root && root.querySelector('.price')) || q(SCOPE + '.price') || q('.price');
  }

  function priceEl() {
    var box = priceBox();
    if (box && box.classList.contains('price--on-sale')) {
      return box.querySelector('.price__sale .price-item--sale');
    }
    if (box) {
      return (
        box.querySelector('.price__regular .price-item--regular') ||
        box.querySelector('span.price-item--regular')
      );
    }
    return q(SCOPE + 'span.price-item--regular') || q('span.price-item--regular');
  }

  function compareEl() {
    var box = priceBox();
    if (!box || !box.classList.contains('price--on-sale')) return null;
    return box.querySelector('.price__sale s.price-item');
  }

  function pickerHost() {
    return (
      q(SCOPE + 'variant-radios') ||
      q(SCOPE + 'variant-selects') ||
      q('variant-radios') ||
      q('variant-selects')
    );
  }

  function selectedVariant() {
    var host = pickerHost();
    if (!host) return null;
    var tag = host.querySelector('script[type="application/json"]');
    if (!tag) return null;
    var variants;
    try {
      variants = JSON.parse(tag.textContent);
    } catch (e) {
      return null;
    }
    if (!variants || !variants.length) return null;

    var options = [];
    var fields = host.querySelectorAll('fieldset');
    if (fields.length) {
      Array.prototype.forEach.call(fields, function (field) {
        var checked = field.querySelector('input[type="radio"]:checked');
        if (checked) options.push(checked.value);
      });
    } else {
      Array.prototype.forEach.call(host.querySelectorAll('select'), function (sel) {
        options.push(sel.value);
      });
    }
    if (!options.length) return null;

    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      var variantOptions = variant.options || [];
      var matched = options.every(function (option, index) {
        return variantOptions[index] === option;
      });
      if (matched) return variant;
    }
    return null;
  }

  function formatMoney(cents, sample) {
    var amount = Number(cents) / 100;
    var text = String(sample || '');
    var symbol = (text.match(/^[^\d\s]+/) || ['$'])[0];
    var code = (text.match(/\s*[A-Za-z]{3}\s*$/) || [''])[0];
    var decimals = /\d[.,]\d{2}(?!\d)/.test(text);
    var grouped = decimals
      ? amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      : Math.round(amount).toLocaleString('en-US');
    return symbol + grouped + code;
  }

  function sameAmount(text, cents) {
    var amount = parseAmount(text);
    return !isNaN(amount) && Math.abs(amount - Number(cents) / 100) < 0.009;
  }

  function parseAmount(text) {
    if (!text) return NaN;
    var clean = String(text).replace(/[^0-9.,]/g, '');
    if (!clean) return NaN;
    var hasComma = clean.indexOf(',') > -1;
    var hasDot = clean.indexOf('.') > -1;
    if (hasComma && hasDot) {
      if (clean.lastIndexOf(',') > clean.lastIndexOf('.')) {
        clean = clean.replace(/\./g, '').replace(',', '.');
      } else {
        clean = clean.replace(/,/g, '');
      }
    } else if (hasComma) {
      var parts = clean.split(',');
      if (parts[parts.length - 1].length === 2) {
        clean = parts.slice(0, -1).join('') + '.' + parts[parts.length - 1];
      } else {
        clean = clean.replace(/,/g, '');
      }
    }
    var val = parseFloat(clean);
    return isNaN(val) ? NaN : val;
  }

  function apply() {
    if (!q('.bnpl')) return;

    var variant = selectedVariant();
    var pEl = priceEl();
    var domPrice = pEl && pEl.textContent ? pEl.textContent.trim() : '';
    var priceText = domPrice;

    if (variant && variant.price != null) {
      if (!domPrice || !sameAmount(domPrice, variant.price)) {
        priceText = formatMoney(variant.price, domPrice || '$0.00 USD');
      }
    }

    if (priceText) {
      all('.bnpl [data-bnpl-price]').forEach(function (n) {
        n.textContent = priceText;
      });
    }

    var cEl = compareEl();
    var domCompare = cEl && cEl.textContent ? cEl.textContent.trim() : '';
    var compareText = '';
    var showCompare = false;

    if (variant && variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
      showCompare = true;
      compareText =
        domCompare && sameAmount(domCompare, variant.compare_at_price)
          ? domCompare
          : formatMoney(variant.compare_at_price, domPrice || priceText);
    } else if (!variant) {
      var price = parseAmount(priceText);
      var compare = parseAmount(domCompare);
      showCompare = !!(domCompare && compare && (!price || compare > price));
      compareText = domCompare;
    }

    all('.bnpl [data-bnpl-compare]').forEach(function (n) {
      if (showCompare) n.textContent = compareText;
    });
    all('.bnpl [data-bnpl-compare-wrap]').forEach(function (n) {
      n.style.display = showCompare ? '' : 'none';
    });
  }

  function bindReactivity() {
    var observed = null;
    function ensureObserver() {
      var host = priceRoot();
      if (!host || host === observed || !window.MutationObserver) return;
      observed = host;
      new MutationObserver(apply).observe(host, {
        subtree: true,
        childList: true,
        characterData: true,
      });
    }
    ensureObserver();

    function onVariantChange() {
      ensureObserver();
      apply();
      setTimeout(apply, 400);
      setTimeout(apply, 1200);
    }

    document.addEventListener('change', function (e) {
      if (
        e.target &&
        e.target.closest &&
        e.target.closest('variant-selects, variant-radios, .product-form, form[action*="/cart/add"]')
      ) {
        onVariantChange();
      }
    });

    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.variantChange
    ) {
      subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
    }
  }

  function wireLogoFallbacks() {
    all('.bnpl__logo-img').forEach(function (img) {
      if (img.__bnplWired) return;
      img.__bnplWired = true;
      var fail = function () {
        if (img.parentNode) img.parentNode.classList.add('bnpl__logo--fallback');
      };
      img.addEventListener('error', fail);
      if (img.complete && img.naturalWidth === 0) fail();
    });
  }

  var started = false;
  function mount() {
    if (!q('.bnpl')) return false;
    apply();
    wireLogoFallbacks();
    if (!started) {
      started = true;
      bindReactivity();
    }
    return true;
  }

  function init() {
    if (mount()) return;
    var tries = 0;
    var timer = setInterval(function () {
      if (mount() || ++tries > 40) clearInterval(timer);
    }, 250);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
